module.exports = __webpack_public_path__ + "img/chess-searchbg4.ab1ee09d.jpg";